import { eSearchOrdersOrderBy } from './eSearchOrdersOrderBy';
import { eInternalOrderStatus } from '../../../enums/eInternalOrderStatus';
import { getISODateTime } from '../../../utilities/getDateString';
import { eOrderGroupCategory } from '../../../enums/eOrderGroupCategory';
import { UUID } from '../../../../types/shared/UUID';
import { eCurativeGrade } from '../../../enums/eCurativeGrade';
import { eUSAState } from '../../../enums/states';
import { eTransactionCategory } from '../../../enums/eTransactionType';
import { eServices } from '../../../enums/eServices';

export interface ISearchOrdersSpecificationData {
  fileNumbers?: string[] | null;
  createdAtStart?: string | null;
  createdAtEnd?: string | null;
  closingDateStart?: string | null;
  closingDateEnd?: string | null;
  partyName?: string | null;
  streetAddress?: string | null;
  unit?: string | null;
  zipCode?: string | null;
  city?: string | null;
  state?: eUSAState | null;
  countyId?: string | null;
  transactionCategory?: eTransactionCategory | null;
  curativeGrades?: eCurativeGrade[] | null;
  loanNumber?: string | null;
  orderGroupCategory?: eOrderGroupCategory | null;
  groupId?: string | null;
  lenderCompanyIds?: string[] | null;
  clientCompanyIds?: string[] | null;
  internalContactAdminId?: string | null;
  statuses?: eInternalOrderStatus[] | null;
  services?: eServices[] | null;
  tag?: UUID;
  externalStatuses?: eInternalOrderStatus[] | null;
  sortBy: eSearchOrdersOrderBy;
  pageNumber: number;
  pageSize: number;
  externalPartyTransactionId?: string;
  allowMultiple?: boolean; // determine whether multiple calls can be made in API request
}

export const createDefaultSearchOrderSpecification = (): ISearchOrdersSpecificationData => ({
  pageNumber: 0,
  pageSize: 100,
  sortBy: eSearchOrdersOrderBy.createdAtDESC,
});

export const convertFromSearchOrdersSpecificationRequestToParameters = (
  data: ISearchOrdersSpecificationData
): ISearchOrdersSpecificationData => ({
  ...data,
  createdAtStart: getISODateTime(data.createdAtStart),
  createdAtEnd: getISODateTime(data.createdAtEnd),
});
